const isOfferSurveyDone = (offerNumber)=>{
    try {
        const offerProcessed = localStorage.getItem('PennyCaresSurveyDict');
        const parsedOfferProcessed = JSON.parse(offerProcessed);
        return parsedOfferProcessed.includes(offerNumber);
    } catch (e) {
        return false;
    }
};
export { isOfferSurveyDone };
